export default __webpack_public_path__ + "i18n/translation-ta.a2ae945b.json";